import getters from './getters';
import actions from './actions';
import mutations from './mutations'
const state = {
    paymentModeList:[],
    paymentMode:{
        label : " "
    }
}

const paymentMode = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default paymentMode;